import React from 'react';
import BlockContentToReact from '@sanity/block-content-to-react';
import { BlockContentProps } from './interfaces';
import { Wrapper } from './BlockContentStyled';
import { serializers } from '@components/Shared/Sanity/serializers';
import { ContentWrapper } from '@components/Post/PostContent/styles';

const BlockContent: React.FC<BlockContentProps> = ({ content }) => {
  if (!content) return <></>;
  return (
    <Wrapper>
      <ContentWrapper>
        <BlockContentToReact blocks={content} serializers={serializers} />
      </ContentWrapper>
    </Wrapper>
  );
};

export default BlockContent;
